export const version = 'HEAD';
export const buildDate = '2026-02-10T20:09:09.863Z';
export const commitHash = 'a760795';